const ChartLegend = ({ items }) => (
  <div
    style={{
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      flexWrap: "wrap",
      gap: "1.25rem",
      marginTop: "0.5rem",
    }}
  >
    {items.map(({ color, label }) => (
      <div
        key={label}
        style={{
          display: "flex",
          alignItems: "center",
          gap: "6px",
          fontSize: 14,
          color: "#333",
        }}
      >
        <span
          style={{
            width: 14,
            height: 14,
            backgroundColor: color,
            display: "inline-block",
            border: "1px solid #333",
            borderRadius: 2,
            flexShrink: 0,
          }}
        />
        <span>{label}</span>
      </div>
    ))}
  </div>
);

export default ChartLegend;
